<template>
    <div class="vx-bg-slate-700 vx-flex vx-items-center vx-p-4 vx-h-16 vx-max-w-full vx-border-0 vx-border-b vx-border-solid vx-border-slate-800 vx-shadow-xl vx-backdrop-blur">
        <slot></slot>
    </div>
</template>
<script setup></script>
